import { Heading } from "@sentricmusic/ui";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useGetMyAccount, useGetMyProfile } from "@/api/queries";
import useSiteConfigAuth from "@/api/sanity/queries/getSiteConfigWithCode";
import { processKycStatuses } from "@/helpers/kycStatus";
import useAppStore from "@/store/appStateZustand";

import StatementsTable from "./StatementsTable";

function Statements() {
  const navigate = useNavigate();
  const { t } = useTranslation("other");
  const profile = useGetMyProfile();
  const selectedAccount = useAppStore(s => s.selectedAccount);
  const myAccount = useGetMyAccount({ artistaccountcode: selectedAccount as string });
  const { data: siteConfig } = useSiteConfigAuth();
  const kyc = useAppStore(s => s.kyc);
  const { showKyc, showKycPending } = processKycStatuses(kyc);
  const hideRoyalties = (siteConfig?.disable_statements === true)
    || (profile?.data?.hideRoyalties === true)
    || showKyc === true
    || showKycPending === true || (myAccount?.data?.hideRoyalties === true);

  // derive isLoading guard as account and profile are async and hideRoyalites could flash navigate to /
  const isLoading = profile.isLoading || myAccount.isLoading || !siteConfig;

  useEffect(() => {
    if (!isLoading && hideRoyalties) {
      void navigate({ to: "/" });
    }
  }, [isLoading, hideRoyalties, navigate]);
  return (
    <div className="flex flex-wrap">
      <div className="w-full lg:min-h-screen-minus-header">
        <div className="mx-4 my-12 lg:mx-12 xl:mx-20 2xl:mx-40">
          <Heading as="h3" className="mb-8">{t("other:statements-header", "Statements")}</Heading>
          <StatementsTable />
        </div>
      </div>
    </div>
  );
}
export default Statements;
